import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import ThongTinCongTy from './ThongTinCongTy';


const useStyles = makeStyles((theme) => ({
    boxTitle: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: '#000',
    },
    boldText: {
        fontWeight: 'bold',
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    // THÊM CLASS MỚI CHO HÌNH ẢNH RESPONSIVE Ở ĐÂY
    responsiveImage: {
        maxWidth: '100%', // Đảm bảo hình ảnh không vượt quá chiều rộng của phần tử cha
        height: 'auto',   // Tự động điều chỉnh chiều cao để duy trì tỷ lệ khung hình
        display: 'block', // Đảm bảo hình ảnh là block-level để áp dụng margin tự động
        margin: theme.spacing(2, 'auto'), // Căn giữa hình ảnh và thêm khoảng cách trên/dưới
    },
}));

const PhuTungChinhHang = () => {
    const classes = useStyles();


    return (
        <Box className={classes.root}>
            <Box className={classes.boxTitle}>
                <Typography variant="h5" className={classes.title}>
                    Phụ tùng và phụ kiện chính hãng ford
                </Typography>
            </Box>
            <Box>
                <Typography component="span" className={classes.boldText}> Sử dụng phụ tùng chính hãng để đảm bảo an toàn cho bạn và gia đình</Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Để tránh những rắc rối gặp phải trên đường, hãy ghé thăm các trung tâm dịch vụ của chúng tôi và bạn sẽ ngay lập tức có cơ hội sử dụng quy trình dịch vụ Quality Care hiện đại và mạng lưới cung cấp phụ tùng tiêu chuẩn của Ford tại Việt nam. Trải qua những thử nghiệm khắt khe nhất của các kỹ sư thiết kế, các phụ tùng cung cấp bởi Ford đảm bảo những tiêu chuẩn cao nhất về phụ tùng chính hãng. Cũng như những gì đã khiến bạn mua chiếc xe Ford ngay từ đầu, khi bạn sử dụng phụ tùng chính hãng bạn có quyền được hưởng đầy đủ mọi chế độ bảo hành của chúng tôi. Ford tự hào là nhà sản xuất phụ tùng với chất lượng tốt nhất. Tất cả các phụ tùng chính hãng của Ford được thiết kế và kiểm tra nghiêm ngặt, đảm bảo rằng không chỉ đáp ứng các tiêu chuẩn thiết kế mà còn vượt ra xa khỏi các tiêu chuẩn nội địa của Việt Nam.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dich-vu-va-bao-duong-tai-dai-ly-ford-3.jpg' className={classes.responsiveImage} alt="Thái Nguyên Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    Ford Thái Nguyên : Dịch vụ mang lại giá trị cho khách hàng
                </Typography>
                <Typography variant="body1" >
                    Từ kinh nghiệm kinh doanh lâu năm tại thị trường Việt Nam, Đại lý Thái Nguyên Ford thấu hiểu rõ những trăn trở, mong muốn của người mua xe Việt, để cung cấp các dịch vụ uy tín, chất lượng:<br />
                    Phụ tùng chính hãng: FORD là nhãn hiệu xe ô tô phổ biến tại Việt Nam, do đó phụ tùng trôi nổi xuất hiện trà lan trên thị trường với chất lượng thấp là điều khách hàng lo ngại mỗi khi cần thay thế phụ tùng, nắm bắt được điều này, Thái Nguyên Ford nỗ lực đảm bảo cung cấp tất cả các phụ tùng bảo dưỡng, sửa chữa chính hãng, nhập khẩu từ Thái Lan, Nhật Bản và các nước trong khu vực, để luôn sẵn sàng đáp ứng nhu cầu của khách hàng một cách nhanh nhất và chất lượng nhất.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/untitled.png' className={classes.responsiveImage} alt="Khai trương đại lý" />

                <br />
                <br />
                <ThongTinCongTy />
            </Box>
        </Box>
    );
};

export default PhuTungChinhHang;